export function encodePassphrase(passphrase: string) {
  return encodeURIComponent(passphrase);
}

export function decodePassphrase(base64String: string) {
  return decodeURIComponent(base64String);
}

export function generateRoomId(): string {
  return `${randomString(4)}-${randomString(4)}`;
}

export function randomString(length: number): string {
  let result = '';
  const characters = 'abcdefghijklmnopqrstuvwxyz0123456789';
  const charactersLength = characters.length;
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}

export function isLowPowerDevice() {
  return navigator.hardwareConcurrency < 6;
}

export function encodeString(inputString: string) {
    if (!inputString) {
        return '';
    }

    if (!containsSpecialCharacters(inputString)) {
        return inputString;
    }

    // Simple encoding without chunking
    return encodeURIComponent(inputString);
}

export function decodeString(inputString: string) {
    if (!inputString) {
        return '';
    }

    try {
        return decodeURIComponent(inputString);
    } catch (e) {
        console.log(`Failed to decodeString ${inputString} with error ${e}`);
        return inputString;
    }
}

export function containsSpecialCharacters(inputS: string){
    if(/^[a-zA-Z0-9-%]*$/.test(inputS) === false){
        return true
    }
    else{
        return false
    }
}
